import { render, staticRenderFns } from "./QuizQuestion.vue?vue&type=template&id=7fe04c34&scoped=true"
import script from "./QuizQuestion.vue?vue&type=script&lang=js"
export * from "./QuizQuestion.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestion.vue?vue&type=style&index=0&id=7fe04c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe04c34",
  null
  
)

export default component.exports